import React from 'react';

import { format } from 'date-fns';
import dayjs from 'dayjs';
import styled from 'styled-components';

import { HOUSING_CONTRACT_STATUS, UNIT_AVAILABILITY } from '../../constants';
import { UnitHousingContractType, UnitType } from '../../types';

const PositiveStatus = styled.span`
  display: flex;
  gap: 4px;
  font-size: 12px;
  color: var(--positive-green);
`;

const NegativeStatus = styled.span`
  font-size: 12px;
  color: var(--negative-orange);
`;

interface Props {
  unit: UnitType;
}

const IncentivesTableUnitsUnitStatus = ({ unit }: Props) => {
  const unitAvailabilityStatus = unit?.unit_availability_status;
  let latestHousingContractMoveOutDate = undefined;

  if ([UNIT_AVAILABILITY.VACANT, UNIT_AVAILABILITY.VACANT_SOON].includes(unitAvailabilityStatus || -1)) {
    const housingContractStatus =
      unitAvailabilityStatus === UNIT_AVAILABILITY.VACANT
        ? HOUSING_CONTRACT_STATUS.PRIOR
        : HOUSING_CONTRACT_STATUS.NOTICE;

    const housingContracts = (unit?.housing_contracts ?? []).filter(
      (hc: UnitHousingContractType) => hc.status == housingContractStatus
    );
    const latestHousingContract = housingContracts?.length ? housingContracts[0] : undefined;
    latestHousingContractMoveOutDate = latestHousingContract?.move_out_date;
  }

  return (
    <>
      {unitAvailabilityStatus === UNIT_AVAILABILITY.OCCUPIED && <NegativeStatus>Occupied</NegativeStatus>}
      {unitAvailabilityStatus === UNIT_AVAILABILITY.VACANT_SOON && (
        <PositiveStatus>
          <span>Vacant</span>
          <span>
            {latestHousingContractMoveOutDate
              ? format(new Date(latestHousingContractMoveOutDate), 'MMM dd')
              : '(No Date)'}
          </span>
        </PositiveStatus>
      )}
      {unitAvailabilityStatus === UNIT_AVAILABILITY.RESERVED && <NegativeStatus>Reserved</NegativeStatus>}
      {unitAvailabilityStatus === UNIT_AVAILABILITY.VACANT && (
        <PositiveStatus>
          <span>Vacant</span>
          {latestHousingContractMoveOutDate && (
            <div style={{ display: 'flex', gap: 4 }}>
              <span>for</span>
              <span>{dayjs().diff(dayjs(latestHousingContractMoveOutDate), 'days')}</span>
              <span>days</span>
            </div>
          )}
        </PositiveStatus>
      )}
    </>
  );
};

export default IncentivesTableUnitsUnitStatus;
